import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4670bcc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "schedule-prompt",
  class: "flex j-evenly section-max-w mlr-auto"
}
const _hoisted_2 = {
  id: "schedule-prompt-text-container",
  class: "flex column align-e"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "schedule-prompt-text mb-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "prompt-header highlight-font-size blurb-highlight" }, " We positively change lives "),
  /*#__PURE__*/_createElementVNode("div", { class: "sub-highlight-font-size" }, " through Applied Behavior Analysis ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "no-wrap-text" }, "consultation  >", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "schedule-prompt-image",
  src: "/images/AdobeStock_271740984-scaled.jpeg",
  alt: "specialist helping student"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, {
        to: "/contact",
        id: "schedule-prompt-link",
        class: "schedule-prompt-text midsize-text text-link-basic"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Schedule your "),
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _hoisted_5
  ]))
}